import types from './types';

import arSummaryService from 'src/services/arSummary';
import arSummaryModel from 'src/model/arSummary.model';

const getArSummary = () => {
  return (dispatch: any) => {
    dispatch(getArSummaryIsPending(true));
    arSummaryService
      .getArSummary()
      .then((response: any) => {
        dispatch(clearArSummary());
        if (response.data) {
          dispatch(setArSummaryContent(response.data));
          dispatch(getArSummaryIsPending(false));
        }
      })
      .catch(error => {
        dispatch(setError('getArSummary', error));
        dispatch(getArSummaryIsPending(false));
      });
  };
};

const getArSummaryIsPending = (isPending: boolean) => {
  return { type: types.GET_AR_SUMMARY_IS_PENDING, payload: isPending };
};

const setArSummaryContent = (content: arSummaryModel) => {
  return { type: types.SET_CONTENT, payload: content };
};

const clearArSummary = () => {
  return { type: types.CLEAR_ALL };
};

const setError = (action: string, error: any) => {
  return {
    type: types.AR_SUMMARY_ERROR,
    payload: { caller: action, error }
  };
};

export default {
  getArSummary
};
